/* eslint-disable no-unused-vars */
import React from 'react';
import {
  Box,
} from '@mui/material';

export default function AdminPageBase({
  children,
}) {
  return (
    <Box sx={{ px: 3, pt: 2 }}>
      {children}
    </Box>
  );
}
